export const getFilterName = (tableFilter) => tableFilter.filterName ?? tableFilter.name;
